











import { PropType, defineComponent, computed } from '@vue/composition-api';
import { MarkdownData, Message } from '../../dataType';
import { parseMarkdownToHtml } from 'zk-editor';
import Card from './Card.vue';

export default defineComponent({
  components: {
    Card
  },
  props: {
    message: {
      type: Object as PropType<Message<MarkdownData>>,
      required: true
    }
  },
  setup(props) {
    const markdown = computed(() => {
      return parseMarkdownToHtml(props.message.content.content);
    });

    return {
      markdown
    };
  }
});
